import {AfterViewInit, Directive, ElementRef, Input, OnDestroy} from '@angular/core';

const DEFAULT_FOCUS_TIMEOUT = 300;

@Directive({
    selector: '[autoFocus]',
})
export class AutoFocusDirective implements AfterViewInit, OnDestroy {
    @Input() autoFocus: boolean;

    private timeout;

    constructor(private elRef: ElementRef) {}

    ngAfterViewInit() {
        this.timeout = setTimeout(() => {
            if (this.elRef.nativeElement && this.autoFocus) {
                this.elRef.nativeElement.focus();
            }
        }, DEFAULT_FOCUS_TIMEOUT);
    }

    ngOnDestroy() {
        clearTimeout(this.timeout);
    }
}
